<template>
  <div class="header-container" :class="{ distributionFlag }">
    <div class="user">
      <div class="user-info">
        <div
          class="avatar"
          :style="{ backgroundImage: 'url(' + avatar_c + ')' }"
        ></div>
        <div class="name-account">
          <div class="name">
            <span>{{ nickname || "游客" }}</span>
            <span class="level" v-if="distributionFlag">
              <i class="level-pre">{{ userInfoRank }}</i>
              <i class="level-val">店长</i>
            </span>
          </div>
          <div class="account">{{ userInfoAccount }}</div>
        </div>
      </div>
      <div class="tools">
        <div class="btn" @click="$router.push({ name: 'Setting' })">
          <img :src="require('@/assets/mine/设置.svg')" alt="" />
          <span>设置</span>
        </div>
        <div
          class="btn"
          v-if="distributionFlag"
          @click="$refs.forward.expandShop()"
        >
          <img :src="require('@/assets/mine/分享店铺.svg')" alt="" />
          <span>分享</span>
        </div>

        <!-- 客户端的消息排版 -->
        <template v-if="!distributionFlag">
          <div class="btn" @click="$router.push({ name: 'MineMessage' })">
            <div v-if="messageTotal" class="badge">
              {{ messageTotal }}
            </div>
            <img :src="require('@/assets/mine/客服.svg')" alt="" />
            <span>消息</span>
          </div></template
        >

        <!-- 分销端的消息排版 -->
        <template v-else>
          <div @click="qiyuOpen" class="btn">
            <img src="@/assets/home/message.svg" alt="" />
            <span>客服</span>
          </div></template
        >
      </div>
    </div>
    <div class="statistics">
      <div class="item" @click="$router.push({ name: 'FollowingAct' })">
        <div class="num">{{ followingActNum }}</div>
        <div class="tit">活动关注</div>
      </div>
      <div class="item" @click="$router.push({ name: 'FollowingBrand' })">
        <div class="num">{{ followingBrandNum }}</div>
        <div class="tit">关注品牌</div>
      </div>
      <div
        class="item"
        @click="$router.push({ name: 'MineLike' })"
        v-if="distributionFlag"
      >
        <div class="num">{{ discoveryNum }}</div>
        <div class="tit">喜欢的发现</div>
      </div>
      <div class="item" @click="$router.push({ name: 'History' })">
        <div class="flex justify-center items-center" style="height: 27px">
          <img
            :src="
              distributionFlag
                ? require('@/assets/mine/浏览记录.svg')
                : require('@/assets/mine/浏览记录白.svg')
            "
            style="height: 20px"
            alt=""
          />
        </div>
        <div class="tit">浏览记录</div>
      </div>

      <!-- 分销端才有的消息提醒 -->
      <div
        class="item"
        v-if="distributionFlag"
        @click="$router.push({ name: 'MineMessage' })"
      >
        <div
          class="flex justify-center items-center"
          style="height: 27px; position: relative"
        >
          <div v-if="messageTotal" class="badge messageTotal">
            {{ messageTotal }}
          </div>
          <img :src="require('@/assets/mine/messageNotification.svg')" alt="" />
        </div>
        <div class="tit" style="color: #333">消息提醒</div>
      </div>
    </div>
    <Forward ref="forward" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
  getFollowingActs,
  getFollowingBrands,
  getDiscoveryLike,
  // getGoodsRecordNum,
} from "../webApi";
import Forward from "./Forward.vue";
import { isWechatMP } from "@/utils/qiyukf";
import { getToken } from "@/utils/auth";
export default {
  components: { Forward },
  data() {
    return {
      qiyuTotal: 0,
      followingActNum: 0,
      followingBrandNum: 0,
      discoveryNum: 0,
      // historyNum: 0,
    };
  },
  watch: {
    $route: {
      handler(val, oval) {
        if (val.name === "Mine" && oval.name === "MineLike") {
          this.getDiscoveryLike();
        }
      },
    },
  },
  created() {
    this.getFollowingActs();
    this.getFollowingBrands();
    if (this.distributionFlag) {
      this.getDiscoveryLike();
    }

    // getGoodsRecordNum().then(({ data }) => {
    //   this.historyNum = data;
    // });
  },
  updated() {
    // 客服消息监听
    if (!isWechatMP) {
      ysf("onunread", function (result) {
        this.qiyuTotal = result.total;
      });
    }
  },
  computed: {
    ...mapGetters(["distributionFlag"]),
    ...mapState({
      nickname: (state) => state.user.userInfoNickname,
      userInfoAccount: (state) => state.user.userInfoAccount,
      userInfoAvatar: (state) => state.user.userInfoAvatar,
      userInfoRank: (state) => state.user.userInfoRank,
    }),
    avatar_c() {
      return this.userInfoAvatar || require("@/assets/setting/avatar.png");
    },
    messageTotal() {
      return this.qiyuTotal + this.$store.state.app.messageNum;
    },
  },
  methods: {
    getFollowingActs() {
      getFollowingActs().then(({ data }) => {
        this.followingActNum = data.length;
      });
    },
    getFollowingBrands() {
      getFollowingBrands().then(({ data }) => {
        this.followingBrandNum = data.length;
      });
    },
    getDiscoveryLike() {
      getDiscoveryLike().then(({ data }) => {
        this.discoveryNum = data;
      });
    },

    // 打开客服
    qiyuOpen() {
      if (!isWechatMP()) {
        ysf("onready", function () {
          ysf("open");
        });
      } else {
        const customerId = this.$store.state.user.customerId;
        const token = getToken();
        const Authorization = "Bearer " + token;
        this.wxjs.miniProgram.navigateTo({
          url: `/pages/kf/kf?customerId=${customerId}&Authorization=${Authorization}`,
          success: function (res) {
            console.log("kfres success", res);
          },
          fail: function (res) {
            console.log("kfres fail", res);
          },
          events: {
            acceptDataFromOpenedPage: function (data) {
              console.log("kf", data);
            },
          },
          complete: function (res) {
            console.log("kfres complete", res);
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 消息提示数量的徽标
.badge {
  position: absolute;
  top: -4px;
  right: -10px;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 18px;
  font-size: 18px;
  padding-top: 4px;
  border-radius: 100%;
  background: #c82d26;
  color: #fff;
}
.header-container {
  color: #fff;
  padding-top: 16px;
  background: #f7b500;
  text-align: left;
  .user {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
  }
  .user-info {
    display: flex;
    .avatar {
      width: 120px;
      height: 120px;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 100%;
    }
    .name-account {
      padding-top: 18px;
      padding-left: 20px;
      .name {
        display: flex;
        align-items: center;
        font-size: 36px;
        line-height: 50px;
        font-weight: 600;
        span:nth-of-type(1) {
          max-width: 5em;
          overflow-x: hidden;
          text-overflow: ellipsis;
        }
        .level {
          display: flex;
          align-items: center;
          margin-left: 12px;
          min-width: 150px;
          height: 36px;
          background-color: #fff;
          background-image: url("~@/assets/mine/等级背景.svg");
          background-size: contain;
          background-position: -1px;
          border-radius: 8px;
          background-repeat: no-repeat;
          i {
            display: inline-block;
            font-size: 20px;
            line-height: 20px;
            color: #333;
            font-style: normal;
            text-align: center;
          }
          .level-pre {
            width: 56px;
          }
          .level-val {
            flex: 1;
            padding: 0 12px;
          }
        }
      }
      .account {
        font-size: 24px;
        line-height: 34px;
      }
    }
  }
  .tools {
    .btn {
      position: relative;
      display: inline-block;
      text-align: center;
      img {
        display: inline-block;
        margin: 0 auto;
        width: 36px;
        height: 36px;
      }
      span {
        display: block;
        font-size: 20px;
        color: #fff;
        line-height: 28px;
      }
      & + .btn {
        margin-left: 16px;
      }
    }
  }
  .statistics {
    position: relative;
    display: flex;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 16px;
    &::after {
      position: absolute;
      content: "";
      height: 200px;
      bottom: -90px;
      left: 0;
      right: 0;
      border-radius: 90px / 90px;
      background: #f7b500;
      z-index: -1;
    }
    .item {
      flex: 4;
      .num {
        font-size: 40px;
        font-weight: 800;
        line-height: 54px;
      }
      .tit {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
      }
      .messageTotal {
        right: 28px;
        top: -14px;
      }
    }
  }
  &.distributionFlag {
    color: #333;
  }
}
</style>
